import { useDomainInfo } from '@/utils'
import { FanaticsCashIcon } from '@/assets/icons'
import { Box } from '@/components'
import { fanaticsCashStyles as styles } from './FanaticsCash.styles'

const FanaticsCash = () => {
  const { isFanaticsDomain } = useDomainInfo()

  if (!isFanaticsDomain) return null

  return (
    <Box sx={styles.wrapper}>
      <FanaticsCashIcon />
    </Box>
  )
}

export default FanaticsCash
